import React from "react";

export interface SlideOptions {
  body: React.ReactNode;
  width?: string;
  minWidth?: string;
  height?: string;
  padding?: string;
  needCloseButton?: boolean;
  direction?: "right" | "left" | "top" | "bottom";
  onClose?: () => void;
  noBackdrop?: boolean; // true일 경우 배경 오버레이 없이 뒤 요소 클릭 가능
}

interface SlideState {
  visible: boolean;
  options: SlideOptions | null;
}

type Listener = (state: SlideState) => void;
type SlideShowListener = (options: SlideOptions) => void;
type SlideHideListener = () => void;

class SlideManagerClass {
  private static instance: SlideManagerClass;
  private listeners: Listener[] = [];
  private showListeners: SlideShowListener[] = [];
  private hideListeners: SlideHideListener[] = [];
  private state: SlideState = {
    visible: false,
    options: null,
  };

  private constructor() {}

  static getInstance(): SlideManagerClass {
    if (!SlideManagerClass.instance) {
      SlideManagerClass.instance = new SlideManagerClass();
    }
    return SlideManagerClass.instance;
  }

  addListener(listener: Listener): void {
    this.listeners.push(listener);
  }

  removeListener(listener: Listener): void {
    this.listeners = this.listeners.filter((l) => l !== listener);
  }

  subscribe(showListener: SlideShowListener, hideListener: SlideHideListener): void {
    this.showListeners.push(showListener);
    this.hideListeners.push(hideListener);
  }

  unsubscribe(showListener: SlideShowListener, hideListener: SlideHideListener): void {
    this.showListeners = this.showListeners.filter((l) => l !== showListener);
    this.hideListeners = this.hideListeners.filter((l) => l !== hideListener);
  }

  show(options: SlideOptions): void {
    const defaultOptions: SlideOptions = {
      body: options.body,
      width: "480px",
      padding: "16px",
      needCloseButton: true,
      direction: "right",
      onClose: () => {},
    };

    const finalOptions = { ...defaultOptions, ...options };

    this.state = {
      visible: true,
      options: finalOptions,
    };
    this.notifyListeners();

    this.showListeners.forEach((listener) => listener(finalOptions));
  }

  hide(): void {
    if (this.state.options?.onClose) {
      this.state.options.onClose();
    }

    this.state = {
      ...this.state,
      visible: false,
    };
    this.notifyListeners();

    this.hideListeners.forEach((listener) => listener());
  }

  hideSlide(): void {
    this.hide();
  }

  private notifyListeners(): void {
    this.listeners.forEach((listener) => listener(this.state));
  }
}

export const SlideManager = SlideManagerClass.getInstance();
